import React, { Fragment, useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemDivider from 'components/NavKit/NavBarListItemDivider'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { TRAVEL_ESSENTIALS_ITEMS } from 'constants/merchandise'
import IconPlaceholder from './components/IconPlaceholder'

const ItemsSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: ${rem(8)};
`

const StyledNavBarListItem = styled(NavBarListItem)`
  padding-block: ${rem(12)};
  gap: ${rem(8)};
`

function MerchandiseTravelEssentialsDrawer() {
  const modalElement = useModalElementContext()

  const handleItemClick = useCallback(() => {
    modalElement.resolve()
  }, [modalElement])

  return (
    <ModalBase mode="drawer">
      <ModalHeader title="Travel Essentials" />
      <ModalBody>
        <ModalContent flush>
          <ItemsSection>
            {TRAVEL_ESSENTIALS_ITEMS.map((item) => (
              <Fragment key={item.id}>
                <StyledNavBarListItem
                  title={item.name}
                  to={item.url}
                  onClick={handleItemClick}
                  endIcon={<IconPlaceholder size={24} />}
                />
                <NavBarListItemDivider />
              </Fragment>
            ))}
          </ItemsSection>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default MerchandiseTravelEssentialsDrawer
